// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.TitleBar_component-wrapper__UMkhG {
  background-color: #333;
  display: flex;
  height: 4rem;
}

.TitleBar_title__8FE-i {
  color: white;
  margin: auto 0 auto 1rem;
  font-size: 1.5rem;
}

.TitleBar_loading-spinner__q7aHu {
  align-self: center;
  margin-left: 10px;
  border: 0.4rem solid white;
  border-top: 0.4rem solid #5CB85C;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  animation: TitleBar_spin__bUkbp 1.5s linear infinite;
}

@keyframes TitleBar_spin__bUkbp {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.TitleBar_content__Hz0BM {
  flex: 1 1;
  color: white;
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/Alarms/components/TitleBar/TitleBar.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,sBDiBU;EChBV,aAAA;EACA,YAAA;AAeF;;AAZA;EACE,YAAA;EACA,wBAAA;EACA,iBAAA;AAeF;;AAZA;EACE,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oDAAA;AAeF;;AAZA;EACE;IAAK,uBAAA;EAgBL;EAfA;IAAO,yBAAA;EAkBP;AACF;AAhBA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AAkBF","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.component-wrapper {\n  background-color: #333;\n  display: flex;\n  height: 4rem;\n}\n\n.title {\n  color: white;\n  margin: auto 0 auto 1rem;\n  font-size: 1.5rem;\n}\n\n.loading-spinner {\n  align-self: center;\n  margin-left: 10px;\n  border: 0.4rem solid white;\n  border-top: 0.4rem solid #5CB85C;\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  animation: spin 1.5s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.content {\n  flex: 1;\n  color: white;\n  display: flex;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"component-wrapper": `TitleBar_component-wrapper__UMkhG`,
	"title": `TitleBar_title__8FE-i`,
	"loading-spinner": `TitleBar_loading-spinner__q7aHu`,
	"spin": `TitleBar_spin__bUkbp`,
	"content": `TitleBar_content__Hz0BM`
};
export default ___CSS_LOADER_EXPORT___;
